export { PullQuote, type PullQuoteProps } from "./pull-quote";
export { PullQuote as default } from "./pull-quote";
